/**
 * Connect More error types
 */
export enum ConnectMoreErrorType {
    General = 'general',
    NoProducts = 'noProducts',
    TooManyRedPlus = 'tooManyRedPlus',
}

/**
 * Connect more error
 */
export type ConnectMoreError = {
    /* eslint-disable jsdoc/require-jsdoc */
    type: ConnectMoreErrorType;
    message: string;
    /* eslint-enable jsdoc/require-jsdoc */
};
